<template>
	<div class="input number" :class="{ 'input-error': errors[id] }">
		<label :for="id" v-if="name">{{ name }}</label>
		<input :id="id" :type=" type ? type : 'text'" v-model="form[id]" :maxlength="maxLength" @keyup="errors[id] = ''" :placeholder="placeholder" v-on:keyup.enter="$emit('enter-pressed')" @keypress="isNumber($event)"/>
		<span class="error-message">{{ errors[id] }}</span>
	</div>
</template>

<script>
	export default {
		props: ['id', 'name', 'form', 'errors', 'placeholder', 'type', 'maxLength'],
		methods: {
			isNumber(evt) {
				evt = (evt) ? evt : window.event;
				var charCode = (evt.which) ? evt.which : evt.keyCode;
				if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
					evt.preventDefault()
				} else {
					return true
				}
			}
		}
	}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/Form/InputNumber.vue